import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesApi } from '../../../infrastructure/api/cases.api';
import { RouteCaseCommand } from './route-case.command';
import { RouteCaseResult } from './route-case.result';

@Injectable({ providedIn: 'root' })
export class RouteCaseUseCase {
  private readonly _api = inject(CasesApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: RouteCaseCommand): Observable<RouteCaseResult> {
    return this._api.routeCase(command.caseId).pipe(
      tap(() => {
        this._toast.success(
          'Case routed',
          'The case has been routed to the next assignee.'
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to route case',
          'Please try again or contact support if the issue persists.'
        );
        return throwError(() => error);
      })
    );
  }
}
